import React, { useState } from 'react'

import { translate } from 'react-i18next'
import { useSelector } from 'react-redux'

import { IconHelper, RECORD_STORAGE_WARNING_PERCENT, clampPercent } from '../../helpers'

const StorageWarningBanner = ({ t }) => {
  const { IconWarningTriangle, IconCircleX, IconClose } = IconHelper
  // both warning and full states are dismissable per requirement; a reload resets it
  const [isDismissed, setIsDismissed] = useState(false)

  const { usage_percent, is_unlimit } = useSelector(state => state.myRecordsUsage)
  const percentUsage = clampPercent(usage_percent)

  // severity is derived purely from Redux usage so it stays in sync with the
  // progress bar and updates automatically when usage is refetched (e.g. after delete)
  let severity = 'none'
  if (!is_unlimit) {
    if (percentUsage >= 100) {
      severity = 'critical'
    } else if (percentUsage >= RECORD_STORAGE_WARNING_PERCENT) {
      severity = 'warning'
    }
  }

  if (severity === 'none' || isDismissed) {
    return null
  }

  const isCritical = severity === 'critical'

  return (
    <div className={`storage-warning-banner ${isCritical ? 'critical' : 'warning'}`}>
      <div className="storage-warning-icon">
        {isCritical ? <IconCircleX color="#B42318" /> : <IconWarningTriangle color="#D92D20" />}
      </div>
      <div className="storage-warning-content">
        {isCritical ? (
          <>
            <div className="storage-warning-title">{t('my_record.storage_full_title')}</div>
            <div className="storage-warning-body">{t('my_record.storage_full_body')}</div>
          </>
        ) : (
          <div className="storage-warning-body">{t('my_record.storage_warning_text')}</div>
        )}
      </div>
      <div className="storage-warning-close" onClick={() => setIsDismissed(true)}>
        <IconClose fill={isCritical ? '#B42318' : '#D92D20'} width="14" height="14" />
      </div>
    </div>
  )
}

export default translate()(StorageWarningBanner)
